import { msg } from '@lingui/core/macro';
import type { FieldMetadataMessageDescriptorDef } from './types';

// The following fields are not guaranteed to be present in all extBATs, but are
// generic/common fields that are shared by more than one extBAT.

export const descriptionField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Description',
    context: 'The display name for a dimension',
  }),
};

export const ghgCategoryField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'GHG category',
    context: 'The display name for the GHG category field',
  }),
};

export const massField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Weight',
    context: 'The display name for mass quantity field',
  }),
};

export const massUnitField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Raw weight unit',
    context: 'The display name for a dimension',
  }),
};

export const genericQuantityField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Quantity',
    context: 'The display name for a metric',
  }),
};

export const genericUnitField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Unit',
    context: 'The display name for a dimension',
  }),
};

export const volumeUnitField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Volume unit',
    context: 'The display name for a dimension',
  }),
};

export const areaUnitField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Area unit',
    context: 'Unit for area quantity',
  }),
};

export const factoryIdField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Factory ID',
    context: 'Factory ID',
  }),
};

export const factoryCountField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Factory count',
    context: 'Tier 1 factory for the reporting company',
  }),
  externalDescription: msg({
    message: 'Tier 1 factory for the reporting company',
    context: 'Factory count',
  }),
};

export const countUnitField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Count unit',
    context: 'Unit column representing a count.',
  }),
};

export const incidentIdField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Incident ID',
    context: 'The display name for a dimension',
  }),
  externalDescription: msg({
    message: 'Unique way to identify the incident.',
    context: 'Incident ID',
  }),
};

export const refrigerantNameField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Refrigerant name',
    context: 'The refrigerant gas name.',
  }),
  externalDescription: msg({
    message: 'The refrigerant gas name.',
    context: 'Refrigerant name',
  }),
};

export const remotePercentageField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Remote percentage',
    context: 'The percent of time an employee works remotely.',
  }),
  externalDescription: msg({
    message: 'The percent of time an employee works remotely.',
    context: 'Remote percentage',
  }),
};

export const naicsCodeField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Industry code',
    context: 'The industry code.',
  }),
  externalDescription: msg({
    message: 'The industry code.',
    context: 'Industry code',
  }),
};

export const employeeQuantityField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Employee quantity',
    context: 'The number of employees.',
  }),
  externalDescription: msg({
    message: 'The number of employees.',
    context: 'Employee quantity',
  }),
};

export const eeioModelKindField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'EEIO model kind',
    context: 'The kind of EEIO model.',
  }),
  externalDescription: msg({
    message: 'The kind of EEIO model.',
    context: 'EEIO model kind',
  }),
};
